import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    employeeActiveButton : {
        name: "Employees"
    },
    employeeDetails: {},
    allEmployees: [], 
    showEmployeeDetailsPopup: false,
    showDeleteEmployeePopup: false,
    blockedEmployees: {}
};


const employeeSlice = createSlice({
    name: "employees",
    initialState,
    reducers: {
        setEmployeeActiveButton: (state, action) => {
            state.employeeActiveButton = action.payload;
        },
        setEmployeeDetails: (state, action) => {
            state.employeeDetails = action.payload;
        },
        setAllEmployees: (state, action) => {
            state.allEmployees = action.payload;
          },
        setShowEmployeeDetailsPopup: (state, action) => {
            state.showEmployeeDetailsPopup = action.payload;
        },
        setShowDeleteEmployeePopup: (state, action) => {
            state.showDeleteEmployeePopup = action.payload;
        },
        setBlockedEmployeeStatus: (state, action) => {
            state.blockedEmployees = action.payload;
        },
        
    }
})


export const { setEmployeeActiveButton, setEmployeeDetails, setAllEmployees, setShowEmployeeDetailsPopup, setShowDeleteEmployeePopup, setBlockedEmployeeStatus } = employeeSlice.actions
export default employeeSlice.reducer;